import React, {Component} from "react";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Button} from "react-bootstrap";
import DirectBillingObservationTypeEnum from "../../../enums/DirectBillingObservationTypeEnum";
import RemotingService from "../../../../../services/remoting-service/RemotingService";
import {base64ToBlob, downloadBlob} from "../../../../../utils/FileDownloader";

export default class ReferralV2ParentObservationSelectModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            observations: [],
            selected: []
        };
    }

    componentDidMount() {
        this.retrieveObservations();
    }

    retrieveObservations() {
        RemotingService.getRemoteCall(`api/insurance/coordinator/v2/referral/${this.props.referralId}/observation`, null, observations => {
            this.setState({observations});
        });
    }

    typeTemplate(observation) {
        return DirectBillingObservationTypeEnum[observation.type]?.name;
    }

    valueTemplate(observation) {
        if (observation.type === "TEXT") {
            return observation.value;
        } else if (observation.type === "FILE") {
            return <span className="cursor-pointer"
                         onClick={() => this.downloadFile(observation)}>
                <u>{observation.filename}</u>
                <FontAwesomeIcon className="ml-1" icon="file-download"/>
            </span>
        }
    }

    downloadFile(observation) {
        downloadBlob(base64ToBlob(observation.value, "application/pdf"), observation.filename);
    }

    valueTypeTemplate(observation) {
        return observation.valueType;
    }

    handleAdd() {
        this.props.onAdd(this.state.selected);
        this.props.close();
    }

    render() {
        return (
            <div style={{width: 800}}>
                <DataTable emptyMessage={"No items found"}
                           value={this.state.observations}
                           columnResizeMode="fit"
                           dataKey="id"
                           selection={this.state.selected}
                           onSelectionChange={(e) => this.setState({selected: e.value})}>
                    <Column selectionMode="multiple" style={{width: 40, textAlign: "center"}}/>
                    <Column header="Type" style={{width: 100}}
                            body={(rowData) => this.typeTemplate(rowData)}/>
                    <Column header="Code" style={{width: "30%", wordWrap: "break-word"}} field="code"/>
                    <Column header="Value"
                            body={(rowData) => this.valueTemplate(rowData)}/>
                    <Column header="Value Type" style={{width: 150}}
                            body={(rowData) => this.valueTypeTemplate(rowData)}/>
                </DataTable>
                <div style={{display: "flex", justifyContent: "flex-end", marginTop: 15}}>
                    <Button variant="primary"
                            disabled={this.state.selected.length === 0}
                            onClick={() => this.handleAdd()}>
                        Add
                    </Button>
                </div>
            </div>
        )
    }
}
